export default [
  {
    path: '/inicio/dashboard',
    name: 'dashboard',
    component: () => import('@/modules/home/dashboard/views/Dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Inicio',
          active: true,
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      resource: 'Dashboard',
      action: 'read',
    },
  },
]
